import React from 'react';
import { Stack, Divider } from '@mui/material';
import { LeadCard } from './LeadCard';
import type { LeadListItem } from '@/api/leads';

interface LeadsCardProps {
  items: LeadListItem[];
  onCardClick: (uuid: string) => void;
}

export const LeadsCard: React.FC<LeadsCardProps> = ({ items, onCardClick }) => {
  return (
    <Stack divider={<Divider flexItem />} spacing={0}>
      {items.map((item) => (
        <LeadCard key={item.key} item={item} onCardClick={onCardClick} />
      ))}
    </Stack>
  );
};

